import { IAxeCreationData } from "@/lib/interfaces and Enums/InterfaceAxes";
import { create } from "zustand";

interface IGeneratedAxe {
  allImportedAxes: IAxeCreationData[];
  // eslint-disable-next-line no-unused-vars
  setAllGeneratedAxes: (incomingData: IAxeCreationData[]) => void;
}

const importedAxesStore = create<IGeneratedAxe>((set) => ({
  allImportedAxes: [],
  setAllGeneratedAxes: (incomingData) => set({ allImportedAxes: incomingData }),
}));

export default importedAxesStore;
